import React, { Component } from 'react';
import styled from 'styled-components';

import { Layout, Breakpoint } from '../../values';
import { Title, Subtitle, Text } from '../style';
import { Input } from '../form';

import ContactForm from '../ContactForm';
import * as form from '../ContactForm/ContactForm';
import validator from 'validator';
import * as socialsIcon from './socials';
import { Button } from 'react-components/dist/buttons/Button';
import { secondaryFont } from 'react-components/dist/values/fonts/fonts';
import { dark, primary, white } from 'react-components/dist/values/colors/colors';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  z-index: 12;
  position: relative;
`;

const Container = styled.div`
  background-color: ${props => props.bg};
  width: 100%;
  color: ${white};
`;

const Inner = styled.div`
  position: relative;
  max-width: ${Layout.maxWidth}px;
  padding: ${Layout.padding};
  margin: ${Layout.margin};
  left: 50%;
  transform: translateX(-55.5%);
  text-align: ${props => (props.center ? 'center' : 'unset')};
`;

const Narrow = styled.div`
  width: 95%;
  max-width: 700px;
  margin: 0 auto;
`;

const Row = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 24px;
  @media (max-width: ${Breakpoint.small}px) {
    flex-direction: column;
    align-items: center;
    & input {
      margin-bottom: 12px;
    }
  }
`;

const Message = styled.div`
  color: ${white};
  font: ${secondaryFont.large};
  text-align: center;
  width: 100%;
  margin-top: -18px;
`;

const Socials = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 12px;
`;

const Social = styled.a`
    color:${white};
    padding: 8px;
    box-sizing:border-box;
    margin:0 6px;
    border: 2px solid ${white};
    border-radius: 6px;
    display:flex;
    justify-content:center;
    align-items:center;
    transition: 0.3s all
    & > svg{
        height: 18px;
        width: 18px;
    }
    &:hover{
        color: ${primary}
        border-color: ${primary}
    }
`;

const Credit = styled.div`
  font: ${secondaryFont.large};
  font-size: 0.8em;
  text-align: center;
`;

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      honeypot: '',
      invalidEmail: false,
      msg: ' '
    };
    this.form = React.createRef();
  }

  handleChange = (el, val) => {
    this.setState({
      ...this.state,
      [el]: val
    });
  };

  subscribe = () => {
    if (!validator.isEmail(this.state.email)) {
      this.setState({
        ...this.state,
        msg: 'Invalid Email Address',
        invalidEmail: true
      });
      return;
    }
    let formData = new FormData();
    formData.append('email', this.state.email);
    formData.append('honeypot', this.state.honeypot);

    fetch('/api/subscribe.php', { method: 'POST', body: formData })
      .then(function(response) {
        return response.text();
      })
      .then(body => {
        try {
          let answer = JSON.parse(body);
          if (answer.success) {
            this.form.current.reset();
            this.setState({
              ...this.state,
              email: '',
              invalidEmail: false,
              msg: 'Thanks for subscribing!'
            });
          } else {
            this.setState({
              ...this.state,
              msg: 'An error occurred, please try again!'
            });
          }
        } catch (e) {
          this.setState({
            ...this.state,
            msg: 'An error occurred, please try again!'
          });
        }
      });
  };

  render() {
    return (
      <Wrapper>
        <Container bg={primary}>
          <Inner>
            <Title
text={this.props.lang === 'fr' ? 'Entrez en contact' : 'Get in touch'}
color={white} />
            <Narrow>
              <ContactForm
lang={this.props.lang}
bg={primary}
source={'Footer'} />
            </Narrow>
          </Inner>
        </Container>
        <Container bg={dark}>
          <Inner center>
            <Subtitle
text={this.props.lang === 'fr' ? 'Restez informé' : 'Stay Informed'}
color={white} />
            <Text
              text={
                this.props.lang === 'fr' ? 'Recevez nos mises à jour trimestrielles' : 'Receive our monthly updates'
              }
              color={white}
            />
            <form
ref={this.form}
style={{ marginTop: 12 }}>
              <Narrow>
                <Row>
                  <div style={{ position: 'absolute', right: 9999999999 }}>
                    <Input
                      light={this.props.light}
                      dark={this.props.dark}
                      placeholder="Put Name Here"
                      type="text"
                      onChange={e => this.handleChange('honeypot', e)}
                      name={'name'}
                    />
                  </div>
                  <Input
                    dark
                    placeholder={this.props.lang === 'fr' ? 'Adresse courriel' : 'Email'}
                    type="email"
                    onChange={e => this.handleChange('email', e)}
                    valid={this.state.invalidEmail}
                    name={'email'}
                  />
                  <div style={{ marginLeft: 24 }}>
                    <Button
                      onClick={() => {
                        this.subscribe();
                      }}
                    >
                      {this.props.lang === 'fr' ? "S'ABONNER" : 'SUBSCRIBE'}
                    </Button>
                  </div>
                </Row>
                <Row>
                  <Message>{this.state.msg}</Message>
                </Row>
              </Narrow>
            </form>
            <Text
              text={this.props.lang === 'fr' ? 'Et suivez-nous sur les réseaux sociaux' : 'And follow us'}
              color={white}
            />
            <Socials>
              <Social
target="_blank"
href="https://www.linkedin.com/company/deepsight-augmented-reality/">
                <socialsIcon.LinkedIn />
              </Social>
              <Social
target="_blank"
href="https://twitter.com/DeepSightAR">
                <socialsIcon.Twitter />
              </Social>
              <Social
target="_blank"
href="https://www.facebook.com/DeepSightAugmentedReality">
                <socialsIcon.Facebook />
              </Social>
              <Social
target="_blank"
href="https://www.instagram.com/deepsight_augmented_reality/">
                <socialsIcon.Instagram />
              </Social>
            </Socials>
          </Inner>
          <Credit>
            {this.props.lang === 'fr'
              ? 'DeepSight 2019 © Tous droits réservés.'
              : 'DeepSight 2019 © All Rights Reserved.'}
          </Credit>
        </Container>
      </Wrapper>
    );
  }
}

export default Footer;
